import useMarkAllAsAcknowledged from './druid/providers/ActivityAcknowledgement/useMarkAllAsAcknowledged';

export default useMarkAllAsAcknowledged;
